export default __webpack_public_path__ + "static/media/Pic8.8dc43683.jpg";